import { render } from "./MessagesAutomatiques.vue?vue&type=template&id=9fb82e9c&scoped=true&ts=true"
import script from "./MessagesAutomatiques.vue?vue&type=script&lang=ts"
export * from "./MessagesAutomatiques.vue?vue&type=script&lang=ts"

import "./MessagesAutomatiques.vue?vue&type=style&index=0&id=9fb82e9c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fb82e9c"]])

export default __exports__